function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.97 12.75H9.53v2.83h5.44c.95 0 1.73-.64 1.73-1.42 0-.78-.78-1.41-1.73-1.41z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.97 15.08h-1.65v1.42c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.42h-1.21v1.42c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.42H7.05c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.98V8.42h-.98c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.06V5.5c0-.41.34-.75.75-.75s.75.34.75.75v1.42h1.21V5.5c0-.41.34-.75.75-.75s.75.34.75.75v1.42h.88c1.55 0 2.92 1.36 2.92 2.92 0 .67-.24 1.28-.62 1.78 1.01.49 1.7 1.45 1.7 2.56 0 1.59-1.45 2.9-3.23 2.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.62 9.83c0-.66-.62-1.42-1.42-1.42H9.53v2.83h4.67c.78.01 1.42-.63 1.42-1.41z"
})));